import { useMsal } from '@azure/msal-react';
import { appConfig } from '../config';
import { ActionButton, untilLeaving } from '../ui/ActionButton';

export function SignInPage() {
  const { instance } = useMsal();

  return (
    <div className="signin-page">
      <div className="signin-card">
        <span className="app-logo large" aria-hidden>
          ✓
        </span>
        <h1>SSP AuditPlus</h1>
        <p>Self Storage Plus audit platform</p>
        <ActionButton
          className="btn btn-primary"
          busyLabel="Signing in…"
          onAction={() =>
            untilLeaving(
              instance.loginRedirect({
                scopes: [...appConfig.graphScopes],
              }),
            )
          }
        >
          Sign in with Microsoft
        </ActionButton>
      </div>
    </div>
  );
}
